// extracted by mini-css-extract-plugin
export default {"note":"AddNote_note__LDkco","note-footer":"AddNote_note-footer__lsr4Z"};